import React from "react";
import {DatePicker, message} from "antd";
import {RouteList} from "../../../models/routes";
import {nameCode, UserContext} from "../../../controller/Utils";
import {SingleRouteDetail} from "./SingleRouteDetail"
import {DispatchHeaderLink} from "../DispatchHeaderLink";
import {Board} from "react-trello";
import "../../../static/css/drag-drop-css.css";
import {Images} from "../../../controller/Images";
import {UpdateRouteOrder} from "../../../models/dispatchMemberRole";

const moment = require('moment');
const _ = require('lodash');

class RoutesPage extends React.Component {
  static contextType = UserContext;
  state = {
    data: [],
    value: [],
    service_date: moment().format('YYYY-MM-DD'),
    modelViewDetails: false,
    updatedLaneData:null,
    dragData: null

  };
  intervalID;
  onDateChange = (date, dateString) => {
    this.setState({service_date: dateString});
    this.fetch({service_date: dateString})
  };
  fetch = (params = {}) => {
    this.setState({params: params});
    params['service_date'] = params.service_date ? params.service_date : this.state.service_date;
    RouteList(params)
      .then(response => {
        const pagination = {...this.state.pagination};
        pagination.total = response.data.count;
        this.setState({
          data: response.data,
          pagination,
          dragData:{'lanes':this.get_data(response.data)}
        });
      });
  };

  componentDidMount() {
    this.fetch();
    this.intervalID = setInterval(this.fetch.bind(this), 60000);
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  nxtDate = (current_date) => {
    const nxtDate = moment(current_date).add(1, 'day').format('YYYY-MM-DD');
    this.setState({service_date: nxtDate});
    this.fetch({service_date: nxtDate});
  };
  prevDate = (current_date) => {
    const prevDate = moment(current_date).subtract(1, 'day').format('YYYY-MM-DD');
    this.setState({service_date: prevDate});
    this.fetch({service_date: prevDate});
  };
  onRowUpdateClick = (row_id) => {
    this.setViewSingleRoute(true);
    this.setState({row_id})
  };

  setViewSingleRoute(row_id, modelViewDetails) {
    this.setState({row_id, modelViewDetails});
  }

  get_data = (data) => {
    let dragData = [];
    for (let i = 0; i < data.length; i++) {
      dragData.push({
        "id": data[i].truck.truck_id,
        "title": <div className="col-12 report-header"><h5> Truck Id: {data[i].truck.truck_id}  </h5></div>,
        "cards": data[i].task.map((task, index) => {
          return {
            id: task.id.toString(),
            title: <div className="col-12 report-generator">
              <h5>Generator Name: <span>{task.generator.company_name}</span></h5>
            </div>,
            description: <div key={index} className="row route-panel-card">

              <div className="col-12 report-content table-responsive">
                <table className="table">
                  <tbody>
                  <tr>
                    {task.members.map((member, index) => {
                      return (
                        <td key={index}>
                          <div className="report-driver">
                            <span>{member.role}</span>
                            <span className="report-driver-img">
                              {member.member.image ?
                                <img alt="Profile image" className="img-fluid"
                                     src={Images.user_image}/> :
                                <div className="icon_div">
                                  <div
                                    className="user_icon">{nameCode(member.member.first_name, member.member.last_name)}</div>
                                </div>
                              }
                            </span>
                            <span>{member.member.first_name} <br/> {member.member.last_name}</span>
                          </div>
                        </td>
                      )
                    })}
                  </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-12 text-center routes-add-div">
                <p>{task.generator.address} {task.generator.city} {task.generator.zip_code}</p>
              </div>
              {task.workorder && task.workorder.hotsheet_id ? <div className="col-12 work-hotsheet-added">
                <p>Hotsheet-WorkOrder</p>
              </div> : ''}
              <div className={`col-12 signed-facility-div ${task.signed_as_facility ? 'signed-by-faci':''}`}>
                <p>{task.signed_as_facility ? "Signed By Facility" : "Not Signed By Facility"}</p>
              </div>
              {task.dispatch &&
              <div className="col-12 report-time">
                <div className="time-div">
                  <span>Start Time</span>
                  <span>{moment(task.dispatch.start_time).format('hh.mm a')}</span>
                </div>
                <div className="time-divider">
                </div>
                <div className="time-div">
                  <span>Stop Time</span>
                  {task.dispatch.end_time &&
                  <span>{moment(task.dispatch.end_time).format('hh.mm a')}</span>}
                </div>
              </div>}
              <div className="col-12 report-footer">
                <div className="view-dtl-btn">
                  <a onClick={() => this.setViewSingleRoute(task.id, true)}>View Details </a>
                </div>
                {task.dispatch ? task.dispatch.status ?
                  <div className="progress-tag"><span className="complete">Completed</span></div> :
                  <div className="progress-tag"><span>In Progress</span></div> :
                  <div className="progress-tag"><span>Not started</span></div>}
              </div>
            </div>
          }
        })
      });
    }
    return dragData
  };

    dataChangeHandle = (newData) => {
        this.setState({dragData: newData});
    };
    changeOrder = (laneId) => {
        const {dragData} = this.state;
        const lane = _.find(dragData['lanes'], function (lane) {
            return lane.id === laneId
        });
        let order = lane.cards.map((data, index) => ({
            id: data.id,
            order: index + 1
        }));
        UpdateRouteOrder({order: order})
            .then(response => {
                message.success("Ticket Order Successfully Updated.")
            });
    };

    handleDragCard(cardId, sourceLaneId, targetLaneId) {
      if(sourceLaneId === targetLaneId) {
        this.changeOrder(targetLaneId)
      }
      else{
        message.warning("Drag cards between the lanes, will not be saved.")
        return false;
      }
    }

  render() {
    const {service_date, dragData} = this.state;

    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB Dispatch</h3>
              </div>
              <div className="col-sm-9 col-12">
                <DispatchHeaderLink user={this.context.user}/>
              </div>
            </div>
            <div className="row clearfix edit-header queue-edit-header">
              <div className="col-sm-3 col-12">
                <div id="date_range_wrapper">
                  <DatePicker className="picker-h-40" onChange={this.onDateChange}/>
                </div>
              </div>
            </div>
            <div className="row date-row">
              <div className="col-sm-3 col-12">
                <button className="btn" onClick={() => this.prevDate(service_date)}><i
                  className="fa fa-angle-left"> </i></button>
              </div>
              <div className="col-sm-6 col-12">
                <p>{service_date}</p>
              </div>
              <div className="col-sm-3 col-12">
                <button type="button" onClick={() => this.nxtDate(service_date)} className="btn pull-right"><i
                  className="fa fa-angle-right"> </i></button>
              </div>
            </div>
            <div className="row clearfix">
              {/*<div className="scroll-row">*/}
              <div className="col-12">
                {!_.isEmpty(dragData) &&
                <div className="report-div">
                  <Board onDataChange={(newData) => this.dataChangeHandle(newData)} disallowAddingCard={true}
                         laneStyle={{margin: 10}}
                         handleDragEnd={(cardId, sourceLaneId, targetLaneId) => this.handleDragCard(cardId, sourceLaneId, targetLaneId)}
                         data={dragData} draggable={true} laneDraggable={false}/>
                </div>}
                <SingleRouteDetail fetchRoute={() => this.fetch()} row_id={this.state.row_id}
                                   visible={this.state.modelViewDetails}
                                   onClose={() => this.setViewSingleRoute(null, false)}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Routes = RoutesPage;



// WEBPACK FOOTER //
// ./src/pages/dispatch/routes/Routes.jsx